<mat-toolbar color="primary">{{ dialogData.title }}</mat-toolbar>

<mat-dialog-content class="border-b border-solid border-slate-100 !p-0">
  <json-editor [options]="editorOptions" [data]="jsonData" />
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="copyToClipboard()">
    <mat-icon>content_copy</mat-icon>
    Copy
  </button>
  <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>
